import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterFlujoCajaResumido from 'views/reports/flujoCajaResumido2/filterFlujoCajaResumido2'; // Importing filter component
import TableFlujoCajaResumido from 'views/reports/flujoCajaResumido2/tableFlujoCajaResumido2'; // Importing table component
import DetailsFlujoCajaResumido from 'views/reports/flujoCajaResumido2/detailsFlujoCajaResumido'; // Importing details component
import RecordFlujoCajaResumido from 'views/reports/flujoCajaResumido2/recordFlujoCajaResumido'; // Importing record component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * SummaryCashFlowView class extends JetView to create a summary cash flow view.
 */
export default class SummaryCashFlowView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        const right = {
            type: 'wide',
            rows: [
                PlayersView, // Players view component
                DetailsFlujoCajaResumido, // Details view component
                RecordFlujoCajaResumido, // Record view component
            ],
        };
        const toolbar = {
            view: 'toolbar', // Toolbar component
            id: 'toolbar', // Toolbar ID
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Toolbar height
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Pager ID
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false, // Disable autosizing
                    height: 35, // Pager height
                    size: 1000000, // Maximum number of items
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export', // Name of the select
                    id: 'Export', // ID of the select
                    width: 120, // Width of the select
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        // Export options
                        { id: '1', value: 'Excel' }, // Excel option
                        { id: '2', value: 'PDF' }, // PDF option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for change event
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('CashResume'); // Get the CashResume table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        // Check for export type
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    // Trigger export event
                                    {
                                        NameReport:
                                            ($$('CashResume').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Flujo Caja Resumido'), // Report name
                                        TypeReport: 'Excel', // Report type
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export to Excel
                                    docHeader: {
                                        text:
                                            _('Descripción del reporte: Flujo Caja Resumido ') +
                                            '\n' +
                                            _('Fecha de reporte: Desde ') +
                                            $$('Datepicker').getValue().substr(0, 10) +
                                            _(' Hasta ') +
                                            $$('Datepicker').getValue().substr(12, 20) +
                                            '\n' +
                                            _(' Fecha creación del reporte: ') +
                                            webix.Date.add(new Date(), -0, 'day').getFullYear() +
                                            '-' +
                                            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
                                            '-' +
                                            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + webix.Date.add(new Date(), -0, 'day').getHours()).slice(-2) +
                                            ':' +
                                            ('00' + webix.Date.add(new Date(), -0, 'day').getMinutes()).slice(-2),
                                        textAlign: 'right', // Align text to the right
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('CashResume').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Flujo Caja Resumido'), // Filename for the export
                                    ignore: { detailTittle: true }, // Ignore detail title
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    this.app.callEvent('export:data', [
                                        // Trigger export event
                                        {
                                            NameReport:
                                                ($$('CashResume').count() > 0 ? '' : _('No hay datos - ')) +
                                                _('Flujo Caja Resumido'), // Report name
                                            TypeReport: 'PDF', // Report type
                                        },
                                    ]);
                                    webix.toPDF($$('CashResume'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('CashResume').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Flujo Caja Resumido'), // Filename for the export
                                        autowidth: true, // Auto width for PDF
                                        ignore: { detailTittle: true }, // Ignore detail title
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        }.bind(this), // Bind the context
                    },
                },
            ],
        };
        const left = {
            css: 'int-left', // CSS class for left section
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Apply theme CSS
                    elements: [
                        { view: 'label', label: _('Flujo de Caja Resumido') }, // Title label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search', // Search button ID
                            cols: [
                                {
                                    view: 'icon', // Icon for search
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        // Click event for search
                                        $$('filterPopup').show(); // Show filter popup
                                    },
                                },
                            ],
                        },
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon', // Icon for close
                                    icon: 'wxi-close', // Close icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                FilterFlujoCajaResumido, // Filter component
                TableFlujoCajaResumido, // Table component
                toolbar, // Toolbar component
            ],
        };
        webix.ui.fullScreen(); // Set UI to full screen
        return {
            id: 'a5', // View ID
            type: 'clean', // Clean type for the view
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    responsive: 'a5', // Responsive design
                    type: 'wide',
                    cols: [left], // Left section
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500 || screen.height < 500) {
                // Check screen size
                $$('toolbar').hide(); // Hide toolbar on small screens
            }
            if (screen.width > 500 && screen.height > 500) {
                // Check screen size
                $$('button-search').hide(); // Hide search button on larger screens
            }
        });
    }
}

// FILE DOCUMENTED
